'use strict';

import React, { PropTypes } from 'react';
import Link from '../atoms/Link';
import Icon from '../atoms/Icon';
import LinkDescription from '../atoms/LinkDescription';
import ContextMenu from '../molecules/ContextMenu';
import ColorPicker from '../organisms/ColorPicker';
import ZineActionCreators from '../actions/ZineActionCreators';
import ZineStatus from '../constants/ZineStatus';
import PureRenderMixin from '../mixins/PureRenderMixin';

const ZineStatusPickerContextMenu = React.createClass({
  mixins: [PureRenderMixin],

  render() {
    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        <Link context='contextMenu'
              underline='never'
              onClick={this.handlePublicClick}
              propagateClick>
          <Icon name='eye'
                mode='stroke'
                size='small'
                margin='right' />
          <b>Public</b>
          <LinkDescription withMaxWidth>
            Collection will be public and visible to anyone on your profile page.
          </LinkDescription>
        </Link>
        <Link context='contextMenu'
              underline='never'
              onClick={this.handleUnlistedClick}
              propagateClick>
          <Icon name='eyeCrossed'
                mode='fill'
                size='small'
                margin='right' />
          <b>Secret</b>
          <LinkDescription withMaxWidth>
            Collection will be visible only to those who have the link.
            It won’t be listed on your profile page.
          </LinkDescription>
        </Link>
      </ContextMenu>
    );
  },

  handlePublicClick() {
    ZineActionCreators.updateZineDraft('status', ZineStatus.PUBLIC);
  },

  handleUnlistedClick() {
    ZineActionCreators.updateZineDraft('status', ZineStatus.UNLISTED);
  }
});

export default ZineStatusPickerContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/ZineStatusPickerContextMenu.jsx
 **/